/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getMostUsedPaymentMethods = (state) => state?.mfeCheckout?.payment?.paymentMethod?.userPaymentMethod?.mostUsed || [];
export const getIsUserSelectPaymentMethod = (state) => state?.mfeCheckout?.payment?.paymentMethod?.userPaymentMethod?.isUserSelectPaymentMethod || false;
export const isPersonlaizedPaymentMethodSelected = (state) => state?.mfeCheckout?.payment?.paymentMethod?.userPaymentMethod?.isPersonlaizedPaymentMethodSelected || false;
export default {};
